/*
 * Shared cart line-item behaviour.
 *
 * Drives the markup rendered by snippets/cart-items-list.liquid, which is used BOTH by
 * the cart page (sections/main-cart) and the cart drawer (via ?section_id=cart-items).
 * Loaded globally alongside cart-items.css so drawer-injected items work on every page.
 *
 * Contract: this module performs the cart mutation, then dispatches
 *   document → CustomEvent('cart:updated', { detail: cart })
 * Each host (cart page / drawer) listens and refreshes itself however it needs to.
 */
(function () {
  // Loaded by both the cart page and the drawer — guard against double-binding.
  if (window.CartItems) return;

  var pendingUpdates = {};
  var debounceTimer = null;

  function emitUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  function syncBadges(cart) {
    var badge = document.querySelector('[data-cart-count]');
    if (badge) badge.textContent = cart.item_count;
    var headerCount = document.querySelector('.header__cart-count');
    if (headerCount) {
      headerCount.textContent = cart.item_count;
      headerCount.style.display = cart.item_count > 0 ? '' : 'none';
    }
  }

  function postUpdates(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        syncBadges(cart);
        if (cart.item_count === 0) { window.location.reload(); return; }
        emitUpdated(cart);
        return cart;
      })
      .catch(function () { window.location.reload(); });
  }

  function flushUpdates() {
    var updates = {};
    Object.keys(pendingUpdates).forEach(function (key) {
      updates[key] = pendingUpdates[key].qty;
    });
    pendingUpdates = {};
    return postUpdates(updates);
  }

  function scheduleUpdate(key, qty) {
    pendingUpdates[key] = { qty: qty };
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(flushUpdates, 400);
  }

  function removeKeys(keys) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return postUpdates(updates);
  }

  /* ── stock cap ── */
  var toastEl = null, toastTimer = null;
  function showStockToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cart-stock-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2500);
  }

  function clampToStock(input, qty) {
    var max = parseInt(input.getAttribute('max'), 10);
    if (max && qty > max) {
      var unitEl = input.parentElement ? input.parentElement.querySelector('.cart-item__qty-unit') : null;
      var unit = unitEl ? unitEl.textContent.trim().toLowerCase() : '';
      showStockToast('Only ' + max + (unit ? ' ' + unit + (max == 1 ? '' : 's') : '') + ' in stock');
      return max;
    }
    return qty;
  }

  /* ── grouped fabric: one input shows the TOTAL; the largest line absorbs the change ── */
  function updateGroupTotal(input, newTotal) {
    newTotal = Math.max(0, newTotal | 0);
    var primaryKey = input.dataset.itemKey;
    var otherMeters = parseInt(input.dataset.otherMeters, 10) || 0;
    var others = [];
    try { others = JSON.parse(input.dataset.groupOthers || '[]'); } catch (e) {}

    var primaryTarget = newTotal - otherMeters;
    if (primaryTarget >= 1) {
      scheduleUpdate(primaryKey, primaryTarget);
    } else {
      scheduleUpdate(primaryKey, 0);
      var need = newTotal;
      others.forEach(function (o) {
        var give = Math.min(o.qty, need);
        if (give !== o.qty) scheduleUpdate(o.key, give);
        need -= give;
        if (need < 0) need = 0;
      });
    }
    input.value = newTotal;
  }

  /* ── delegated interactions ── */
  document.addEventListener('click', function (e) {
    var groupRemove = e.target.closest('.cart-group__remove');
    if (groupRemove) {
      var keys = (groupRemove.dataset.groupKeys || '').split(',').filter(Boolean);
      if (!keys.length) return;
      groupRemove.disabled = true;
      removeKeys(keys);
      return;
    }

    // The cart page shows a confirm popup for single removes; if that popup isn't on the
    // page (e.g. inside the drawer), remove directly instead.
    var removeBtn = e.target.closest('.cart-item__remove');
    if (removeBtn && !document.getElementById('cart-remove-popup')) {
      var row = removeBtn.closest('.cart-item');
      if (row) row.classList.add('is-removing');
      removeKeys([removeBtn.dataset.itemKey]);
      return;
    }

    var qtyBtn = e.target.closest('.cart-item__qty-btn');
    if (qtyBtn) {
      var stepper = qtyBtn.closest('.cart-item__qty-stepper');
      var input = stepper.querySelector('.cart-item__qty-input');
      var current = parseInt(input.value, 10) || 1;
      var newQty = qtyBtn.dataset.action === 'plus' ? current + 1 : Math.max(1, current - 1);
      newQty = clampToStock(input, newQty);
      if (newQty === current) { input.value = current; return; }
      input.value = newQty;
      if (input.dataset.groupTotal) { updateGroupTotal(input, newQty); return; }
      scheduleUpdate(qtyBtn.dataset.itemKey, newQty);
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('cart-item__qty-input')) return;
    var input = e.target;
    var newQty = parseInt(input.value, 10);
    if (isNaN(newQty) || newQty < 1) newQty = 1;
    newQty = clampToStock(input, newQty);
    input.value = newQty;
    if (input.dataset.groupTotal) { updateGroupTotal(input, newQty); return; }
    scheduleUpdate(input.dataset.itemKey, newQty);
  });

  window.CartItems = {
    scheduleUpdate: scheduleUpdate,
    flushUpdates: flushUpdates,
    removeKeys: removeKeys
  };
})();
